export type InspectionType =
	| 'yellow-card'
	| 'directed'
	| 'see-act'
	| 'interaction'

export const INSPECTION_TYPE_LABELS: Record<InspectionType, string> = {
	'yellow-card': 'Cartão Amarelo',
	directed: 'Direcionada',
	'see-act': 'Ver e Agir',
	interaction: 'Interação',
}
